module.exports = __webpack_public_path__ + "cuttingLineTop.webp?70d750321ccef3ebae1dd88874dbf51b";